









import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Const } from '@/const'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { CurveLayer } from '@/model/document2/page/surface/design/layer/curveLayer';
import { SVGPathData, SVGPathDataTransformer, SVGPathDataParser } from 'svg-pathdata';
import { CommandM, CommandC, CommandS } from 'node_modules/svg-pathdata/lib/types';
import { UserAgentHelper } from '@/helper/userAgentHelper';

@Component({
    components: {
    },
})
export default class CurveLayerDrawer extends Vue {
  
    @Prop() private layer!: CurveLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;

    private get isElectronWin()
    {
        return UserAgentHelper.isElectron() && UserAgentHelper.getOS() != "MacOS";
    }

    private get boundsX()
    {
        return this.layer.getBoundingRect().x * this.scale + this.offsetX;
    }

    private get boundsY()
    {
        return this.layer.getBoundingRect().y * this.scale + this.offsetY;
    }

    private get boundsWidth()
    {
        return Math.max(this.layer.getBoundingRect().width * this.scale, 1);
    }

    private get boundsHeight()
    {
        return Math.max(this.layer.getBoundingRect().height * this.scale, 1);
    }

    static readonly MOVE_TO = 2;
    static readonly CURVE_TO = 32;
    static readonly SMOOTH_CURVE_TO = 64;

    private get pathArray()
    {
        var path = new SVGPathData(this.layer.svgPath);
        // スケーリング
        path = path.scale(this.scale, this.scale);
        // オフセット
        path = path.translate(this.offsetX, this.offsetY);
        // 制御点単位で分割する
        var commands = path.commands;
        var pathArray : Array<{path : string, index : number}> = new Array();
        var x;
        var y;
        var index = 0;
        for(var i = 0; i < commands.length; ++i)
        {
            if(commands[i].type == CurveLayerDrawer.MOVE_TO)
            {
                var commandM = commands[i] as CommandM;
                x = commandM.x;
                y = commandM.y;
            }
            else
            {
                var newCommands = new Array();
                newCommands.push({ type: CurveLayerDrawer.MOVE_TO, relative: false, x: x, y: y });
                newCommands.push(commands[i]);
                
                if(commands[i].type == CurveLayerDrawer.CURVE_TO)
                {
                    var commandC = commands[i] as CommandC;
                    x = commandC.x;
                    y = commandC.y;
                }
                else if(commands[i].type == CurveLayerDrawer.SMOOTH_CURVE_TO)
                {
                    var commandS = commands[i] as CommandS;
                    x = commandS.x;
                    y = commandS.y;
                }

                var newPathData = new SVGPathData(newCommands);
                pathArray.push({path : newPathData.encode(), index: index++});
            }
        }
        return pathArray;
    }

    public get stokeColor() : string
    {
        var r = this.layer.strokeColor.r;
        var g = this.layer.strokeColor.g;
        var b = this.layer.strokeColor.b;

        return "rgb(" + r + "," + g + "," + b + ")";
    }

    private get opacity()
    {
        return this.layer.opacity / 100;
    }

    public get strokeWidth() : number
    {
        // 太さはスケーリングする
        return this.layer.strokeWidth * this.scale;
    }

    private onMouseOver(index)
    {
        this.layer.isTouched = true;
        this.layer.lastTouchedIndex = index;
    }

    private onMouseOut()
    {
        this.layer.isTouched = false;
    }
}
